<template>
  <div class="wrapper">
    <header>
      <em class="logo">UED-CDN</em>
      <p>前端公共静态资源CDN加速服务</p>
    </header>
    <section>
      <div class="static-list">
        <router-link
          class="static-item"
          target="_blank"
          :to="item.router"
          v-for="item in list"
          :key="item.label"
        >
          <div class="img-box"><img :src="item.src" /></div>
          <em>{{ item.label }}</em>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import vue from "../assets/images/vue.png";
import react from "../assets/images/react.png";
import jquery from "../assets/images/jquery.png";
import bootstrap from "../assets/images/bootstrap.png";
import zepto from "../assets/images/zepto.png";
import elementUi from "../assets/images/element-ui.png";
import mintUi from "../assets/images/mint-ui.png";
import iview from "../assets/images/iview.png";
import lodash from "../assets/images/lodash.png";
import moment from "../assets/images/moment.png";
import normalize from "../assets/images/normalize.png";
import echarts from "../assets/images/echarts.png";
import groceries from "../assets/images/javascript.png";
import swiper from "../assets/images/swiper.png";
import gc from "../assets/images/gc-logo.png";
import baohe from "../assets/images/baohe.png";
import cloudPrint from "../assets/images/cloudPrint.png";
import ckeditor4 from "../assets/images/ckeditor4.png";
import three from "../assets/images/three.jpg";
import zui from "../assets/images/zui.png";
import working from "../assets/images/working.png";
import zgp from "../assets/images/zgp.png";
import vant from "../assets/images/vant.png";
import day from "../assets/images/day.png";

export default {
  name: "index",
  data() {
    return {
      list: [
        {
          label: "vue",
          router: "vue",
          src: vue
        },
        {
          label: "vue3",
          router: "vue3",
          src: vue
        },
        {
          label: "vue-patches",
          router: "vue-patches",
          src: vue
        },
        {
          label: "vuex",
          router: "vuex",
          src: vue
        },
        {
          label: "vue-router",
          router: "vue-router",
          src: vue
        },
        {
          label: "vue-filter",
          router: "vue-filter",
          src: vue
        },
        {
          label: "axios",
          router: "axios",
          src: vue
        },
        {
          label: "react",
          router: "react",
          src: react
        },
        {
          label: "jquery",
          router: "jquery",
          src: jquery
        },
        {
          label: "zepto",
          router: "zepto",
          src: zepto
        },
        {
          label: "element-ui",
          router: "elementUi",
          src: elementUi
        },
        {
          label: "mint-ui",
          router: "mintUi",
          src: mintUi
        },
        {
          label: "iview",
          router: "iview",
          src: iview
        },
        {
          label: "bootstrap",
          router: "bootstrap",
          src: bootstrap
        },
        {
          label: "lodash",
          router: "lodash",
          src: lodash
        },
        {
          label: "moment",
          router: "moment",
          src: moment
        },
        {
          label: "normalize",
          router: "normalize",
          src: normalize
        },
        {
          label: "echarts",
          router: "echarts",
          src: echarts
        },
        {
          label: "swiper",
          router: "swiper",
          src: swiper
        },
        {
          label: "葡萄城",
          router: "gc",
          src: gc
        },
        {
          label: "宝盒SDK",
          router: "baohe",
          src: baohe
        },
        {
          label: "云打印SDK",
          router: "cloudPrint",
          src: cloudPrint
        },
        {
          label: "zcat SDK",
          router: "zcat",
          src: groceries
        },
        {
          label: "CKEdior4",
          router: "ckeditor4",
          src: ckeditor4
        },
        {
          label: "其他库存",
          router: "groceries",
          src: groceries
        },
        {
          label: "three",
          router: "three",
          src: three
        },
        {
          label: "Additional",
          router: "additional",
          src: groceries
        },
        {
          label: "Zui",
          router: "zui",
          src: zui
        },
        {
          label: "Zui Patches",
          router: "zui-patches",
          src: zui
        },
        {
          label: "Zui-screw",
          router: "zui-screw",
          src: zui
        },
        {
          label: "Zui-qk",
          router: "zui-qk",
          src: zui
        },
        {
          label: "工作台",
          router: "working",
          src: working
        },
        {
          label: "jquery.qrcode",
          router: "jquery.qrcode",
          src: groceries
        },
        {
          label: "ZGP",
          router: "zgp",
          src: zgp
        },
        {
          label: "zpush SDK",
          router: "zpush",
          src: groceries
        },
        {
          label: "Vant",
          router: "vant",
          src: vant
        },
        {
          label: "ZtoAd",
          router: "zto-ad",
          src: groceries
        },
        {
          label: "ZtoWebrtc",
          router: "zto-webrtc",
          src: groceries
        },
        {
          label: "Clickstream",
          router: "clickstream",
          src: groceries
        },
        {
          label: "printSdk",
          router: "printSdk",
          src: groceries
        },
        {
          label: "phone-sdk",
          router: "phone-sdk",
          src: groceries
        },
        {
          label: "day",
          router: "day",
          src: day
        },
        {
          label: "micro 工具",
          router: "micro",
          src: groceries
        },
        {
          label: "xlsx",
          router: "xlsx",
          src: groceries
        },
        {
          label: "invoice-sdk",
          router: "invoice-sdk",
          src: groceries
        },
        {
          label: "lowcode-renderer",
          router: "lowcode-renderer",
          src: groceries
        },
        {
          label: "vconsole",
          router: "vconsole",
          src: groceries
        },
        {
          label: "掌中通SDK",
          router: "zzt-sdk",
          src: groceries
        },
        {
          label: "RegistSDK",
          router: "regist-sdk",
          src: groceries
        },
        {
          label: "ZtoMap",
          router: "zto-map",
          src: groceries
        },
        {
          label: "mzui",
          router: "mzui",
          src: vue
        },
        {
          label: "html2canvas",
          router: "html2canvas",
          src: groceries
        },
        {
          label: "vue-office-docx",
          router: "vue-office-docx",
          src: groceries
        },
        {
          label: "vue-office-pdf",
          router: "vue-office-pdf",
          src: groceries
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/Index.vue